// User-friendly Finnish time/date formatting for the messaging UI.
function toDate(iso) { try { return new Date(iso); } catch { return null; } }

function sameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function fmtTime(iso) {
  const d = toDate(iso);
  if (!d || isNaN(d)) return "";
  return d.toLocaleTimeString("fi-FI", { hour: "2-digit", minute: "2-digit" });
}

// Conversation list: today -> HH:mm, yesterday -> "Eilen", same year -> "17.7.", else "17.7.2025"
export function fmtConvoTime(iso) {
  const d = toDate(iso);
  if (!d || isNaN(d)) return "";
  const now = new Date();
  if (sameDay(d, now)) return d.toLocaleTimeString("fi-FI", { hour: "2-digit", minute: "2-digit" });
  const y = new Date(now); y.setDate(now.getDate() - 1);
  if (sameDay(d, y)) return "Eilen";
  if (d.getFullYear() === now.getFullYear()) return `${d.getDate()}.${d.getMonth() + 1}.`;
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
}

// Date separator inside a chat: "Tänään" / "Eilen" / "17.7." / "17.7.2025"
export function dateSeparatorLabel(iso) {
  const d = toDate(iso);
  if (!d || isNaN(d)) return "";
  const now = new Date();
  if (sameDay(d, now)) return "Tänään";
  const y = new Date(now); y.setDate(now.getDate() - 1);
  if (sameDay(d, y)) return "Eilen";
  if (d.getFullYear() === now.getFullYear()) return `${d.getDate()}.${d.getMonth() + 1}.`;
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
}

export function isNewDay(prevIso, curIso) {
  const a = toDate(prevIso), b = toDate(curIso);
  if (!a || !b || isNaN(a) || isNaN(b)) return true;
  return !sameDay(a, b);
}
